export const blogPosts = [
  {
    id: 1,
    title: "5 Morning Micro-Habits That Transform Family Life",
    excerpt: "Discover how five simple morning actions, done together, can create lasting change in your family's daily rhythm and connection.",
    pillar: "Family",
    image: "https://public.readdy.ai/ai/img_res/47b6730c007addcdd9efe6df0f0019f9.jpg",
    date: "2024-03-15",
    readTime: "6 min read"
  },
  {
    id: 2,
    title: "Faith-Based Gratitude: A 2-Minute Daily Practice",
    excerpt: "Learn how a simple gratitude practice rooted in faith can shift your family's perspective and deepen spiritual connection.",
    pillar: "Faith",
    image: "https://readdy.ai/api/search-image?query=family%20praying%20together%20holding%20hands%20around%20table%20peaceful%20moment%20soft%20natural%20lighting%20warm%20tones%20spiritual%20atmosphere%20simple%20home%20setting%20gratitude%20and%20reflection&width=800&height=500&seq=blog2&orientation=landscape",
    date: "2024-03-12",
    readTime: "5 min read"
  },
  {
    id: 3,
    title: "Habit Stacking for Busy Parents: Start Small, Win Big",
    excerpt: "Master the art of habit stacking to build sustainable routines without adding more to your already full plate.",
    pillar: "Family",
    image: "https://readdy.ai/api/search-image?query=organized%20parent%20planning%20daily%20schedule%20with%20children%20in%20cozy%20living%20room%20natural%20light%20warm%20colors%20family%20calendar%20on%20wall%20peaceful%20home%20environment%20lifestyle%20photography&width=800&height=500&seq=blog3&orientation=landscape",
    date: "2024-03-10",
    readTime: "7 min read"
  },
  {
    id: 4,
    title: "Building Financial Wisdom Through Micro-Actions",
    excerpt: "Small daily financial habits that teach children stewardship and help families build lasting wealth together.",
    pillar: "Finances",
    image: "https://readdy.ai/api/search-image?query=parent%20teaching%20child%20about%20money%20savings%20jar%20on%20table%20warm%20home%20setting%20natural%20lighting%20educational%20moment%20simple%20background%20family%20financial%20literacy&width=800&height=500&seq=blog4&orientation=landscape",
    date: "2024-03-08",
    readTime: "6 min read"
  },
  {
    id: 5,
    title: "The 10-Minute Family Fitness Ritual",
    excerpt: "Transform your family's health with a simple 10-minute movement practice that everyone can do together, every day.",
    pillar: "Fitness",
    image: "https://readdy.ai/api/search-image?query=family%20exercising%20together%20outdoors%20in%20park%20parents%20and%20children%20doing%20simple%20stretches%20morning%20sunlight%20active%20lifestyle%20joyful%20atmosphere%20natural%20setting&width=800&height=500&seq=blog5&orientation=landscape",
    date: "2024-03-05",
    readTime: "5 min read"
  },
  {
    id: 6,
    title: "Meal Prep as a Family Bonding Experience",
    excerpt: "Turn Sunday meal prep into a weekly tradition that teaches life skills and creates meaningful family memories.",
    pillar: "Food",
    image: "https://readdy.ai/api/search-image?query=family%20cooking%20together%20in%20bright%20kitchen%20parents%20and%20children%20preparing%20healthy%20meals%20fresh%20vegetables%20on%20counter%20warm%20natural%20light%20joyful%20bonding%20moment&width=800&height=500&seq=blog6&orientation=landscape",
    date: "2024-03-03",
    readTime: "8 min read"
  }
];

export const featuredPost = blogPosts[0];

export const pillarCategories = [
  { name: "Faith", count: 12, color: "bg-amber-100 text-amber-800" },
  { name: "Family", count: 18, color: "bg-rose-100 text-rose-800" },
  { name: "Friends", count: 8, color: "bg-emerald-100 text-emerald-800" },
  { name: "Fitness", count: 14, color: "bg-cyan-100 text-cyan-800" },
  { name: "Finances", count: 10, color: "bg-violet-100 text-violet-800" },
  { name: "Food", count: 15, color: "bg-orange-100 text-orange-800" },
  { name: "Fun", count: 11, color: "bg-pink-100 text-pink-800" }
];